import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { SummaryPriceDetailsStyled } from '../SummaryPriceDetailsStyled';
import { rem } from 'polished';

export const SummaryPriceDetailsAP = styled(SummaryPriceDetailsStyled)`
    .totalPriceWrapper {
        @media (max-width: ${breakpoints.md}px) {
            display: flex;

            .totalPrice {
                padding-top: unset !important;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
            }
        }
    }

    .configuration {
        button {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            color: ${({ theme }) => theme.colors.primary};

            svg {
                margin-top: 0;

                path {
                    fill: ${({ theme }) => theme.colors.primary} !important;
                }
            }

            &:hover,
            &:focus-visible {
                text-decoration: underline;
            }
        }
    }
`;
